import { useEffect } from 'react'

import { logger } from '@/modules/utils'

import { PinStatus } from '../codegen/graphql'
import { useWhoAmI } from './useWhoAmI'

/**
 * Whether the GxP add-on is enabled for this environment — the gate for all
 * compliance/signing UI. Driven by the BFF's `gxp_enforcement_enabled` flag,
 * which the `pin_status` resolver surfaces as `DISABLED` when off. A user who
 * simply hasn't set their PIN yet resolves to `NOT_SET` (not `DISABLED`), so
 * this stays true for them. Also false when unauthenticated / whoAmI errors
 * (fail-closed) and until `whoAmI` resolves. Mirrors the run-time check in
 * `useGxpAction`.
 */
export function useGxpEnabled(): boolean {
  const { data: whoAmI, error } = useWhoAmI()

  useEffect(() => {
    if (error) {
      // Don't silently swallow a failed whoAmI — a degraded result here makes
      // GxP look disabled, so surface it for diagnosis.
      logger.error('useGxpEnabled: failed to resolve whoAmI', error)
    }
  }, [error])

  return whoAmI !== undefined && whoAmI.pinStatus !== PinStatus.Disabled
}
